import {APP_INITIALIZER, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {fetchUser} from './initializers/user.initializer';
import {UserService} from './services/user.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: fetchUser,
            deps: [UserService],
            multi: true,
        },
    ],
})
export class UserModule {
}
